<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width: 100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
        </a-anchor>
        <a-page-header class="fun-panel" title="会议报名表" :sub-title="subTitle" @back="onBack">
            <template v-slot:extra>
                <a-button :loading="loading || saving" v-if="editData.djzt === '提交'" type="danger" v-show="submitShow" @click="unSubmit">撤销</a-button>
            </template>
            <a-divider></a-divider>
            <a-layout>
                <a-layout-content>
                    <a-spin :spinning="loading">
                        <a-form ref="form" class="fun-edit-form" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                            <FGCollapsiblePanel title="会议报名录入">
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="6">
                                        <a-form-item label="会议报名单编号">
                                            <a-input ref="hybmdbh" v-model="editData.hybmdbh" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="报名日期">
                                            <a-input ref="bmrq" v-model="editData.bmrq" class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="会议名称">
                                            <a-input ref="hymc" v-model="editData.hymc" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="会议类别">
                                            <a-input ref="hylb" v-model="editData.hylb" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="6">
                                        <a-form-item label="报名开始时间">
                                            <a-input ref="ksrq" v-model="editData.ksrq" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="报名结束时间">
                                            <a-input ref="jsrq" v-model="editData.jsrq" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="会议开始时间">
                                            <a-input ref="hyksrq" v-model="editData.hyksrq" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="会议结束时间">
                                            <a-input ref="hyjsrq" v-model="editData.hyjsrq" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="12">
                                        <a-form-item label="会议主要内容" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                                            <a-textarea ref="zynr" :rows="3" v-model="editData.zynr" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="开会地点">
                                            <a-input ref="hydd" v-model="editData.hydd" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="联系人">
                                            <a-input ref="lxr" v-model="editData.lxr" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="6">
                                        <a-form-item label="联系电话">
                                            <a-input ref="lxdh" v-model="editData.lxdh" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="纳税人识别号">
                                            <a-input ref="nsrsbh" v-model="editData.nsrsbh" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <!--                                    <a-col :span="6">
                                        <a-form-item label="是否交费">
                                            <FGDictSelectCN ref="sfjf" dictNo="1101" v-model="editData.sfjf" disabled class="view" />
                                        </a-form-item>
                                    </a-col>-->
                                    <a-col :span="6">
                                        <a-form-item label="是否收费">
                                            <FGDictSelectCN ref="sfsf" dictNo="1101" v-model="editData.sfsf" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="录入人">
                                            <a-input ref="lrrxm" v-model="editData.lrrxm" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="6">
                                        <a-form-item label="录入部门">
                                            <a-input ref="lrbmmc" v-model="editData.lrbmmc" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="录入时间">
                                            <a-input ref="lrrq" v-model="editData.lrrq" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="12">
                                        <a-form-item label="备注" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                                            <a-textarea ref="bz" :rows="3" v-model="editData.bz" class="view" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </FGCollapsiblePanel>
                            <FGCollapsiblePanel title="会议报名单明细">
                                <vxe-table
                                    ref="tree"
                                    size="mini"
                                    resizable
                                    keep-source
                                    auto-resize
                                    row-id="id"
                                    align="left"
                                    header-align="center"
                                    highlight-hover-row
                                    highlight-current-row
                                    show-overflow="tooltip"
                                    :tree-config="{ trigger: 'cell' }"
                                    :data="tableData"
                                    :edit-config="{
                                        trigger: 'click',
                                        mode: 'row',
                                        showStatus: true,
                                        showIcon: false
                                    }"
                                >
                                    <vxe-table-column field="xh" title="序号" width="70px" align="center" sortable> </vxe-table-column>
                                    <vxe-table-column field="xm" title="报名人员" align="center"> </vxe-table-column>
                                    <vxe-table-column field="xb" title="性别" width="70px" align="center"> </vxe-table-column>
                                    <vxe-table-column field="mz" title="民族" width="80px" align="center"> </vxe-table-column>
                                    <vxe-table-column field="sj" title="手机" align="center"> </vxe-table-column>
                                    <vxe-table-column field="dzyx" title="电子发票收件人邮箱" width="80px" align="center"> </vxe-table-column>
                                    <vxe-table-column field="lxdh" title="联系电话" align="center"> </vxe-table-column>
                                    <vxe-table-column field="sfzh" title="身份证号" align="center"> </vxe-table-column>
                                    <vxe-table-column field="dwdz1" title="单位地址" align="center"> </vxe-table-column>
                                    <vxe-table-column field="dwlx" title="单位类型" align="center"> </vxe-table-column>
                                    <vxe-table-column field="zwzc" title="职务或职称" align="center"> </vxe-table-column>
                                    <vxe-table-column field="sfzs" title="是否住宿" width="70px" align="center">
                                        <template v-slot="{ row }">
                                            <FGDictRenderer dictNo="B0001" v-model="row.sfzs" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="zsyq" title="住宿要求" align="center"> </vxe-table-column>
                                    <vxe-table-column field="jhrdsj" title="计划入店时间" align="center"> </vxe-table-column>
                                    <vxe-table-column field="jhldsj" title="计划离店时间" align="center"> </vxe-table-column>
                                    <vxe-table-column field="sfyc" title="是否用餐" width="70px" align="center">
                                        <template v-slot="{ row }">
                                            <FGDictRenderer dictNo="B0001" v-model="row.sfyc" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="bz" title="备注" width="220px" align="center"> </vxe-table-column>
                                </vxe-table>
                            </FGCollapsiblePanel>
                            <!-- 操作日志 -->
                            <OperLog ref="operlog" :operLogProps="operLogProps"></OperLog>
                        </a-form>
                    </a-spin>
                </a-layout-content>
            </a-layout>
        </a-page-header>
    </div>
</template>

<script>
export default {
    name: "BmslqrEdit",
    props: ["showEdit", "dataId"],
    data() {
        return {
            // 避免重复点击提交
            saving: false,
            // 主表数据
            editData: {},
            editDataLoading: false,
            isnew: true,
            tableData: [],
            submitShow: true,
            isShow_hyxx: false,
            // 流程跟踪参数
            operLogProps: {
                visible: false,
                billid: null
            }
        };
    },
    computed: {
        subTitle() {
            return "查看";
        },
        // 是否显示编辑界面
        formIsVisible: {
            get() {
                return this.showForm;
            },
            set(newVal) {
                this.$emit("update:showForm", newVal);
                this.operLogProps.visible = newVal;
            }
        },
        // 当前编辑记录id
        editDataId: {
            get() {
                return this.dataId;
            },
            set(newVal) {
                this.$emit("update:dataId", newVal);
            }
        },
        loading() {
            return this.editDataLoading;
        }
    },
    activated() {
        this.loadData();
        this.loadTableData();
    },
    methods: {
        saveEvent_hyxx(val, currentrow) {
            if (val && val.length > 0) {
                this.editData.hymc = val[0][0].HYMC;
                this.editData.hylb = val[0][0].HYLB;
                this.editData.ksrq = val[0][0].KSRQ;
                this.editData.jsrq = val[0][0].JSRQ;
                this.editData.hyksrq = val[0][0].HYKSRQ;
                this.editData.hyjsrq = val[0][0].HYJSRQ;
                this.editData.zynr = val[0][0].ZYNR;
                this.editData.hydd = val[0][0].HYDD;
                this.editData.lxr = val[0][0].LXR;
                this.editData.lxdh = val[0][0].LXDH;
            }
        },
        // 根据id查询需要编辑的数据
        loadData() {
            this.editData = {};
            this.editDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/hybm/selectById",
                    {
                        id: this.editDataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.editData = data.data;
                            this.initOperLog();
                        } else {
                            // 加载的数据不存在则提示错误并关闭编辑窗口
                            this.$FG_message.error("P0002").then(() => (this.editIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则关闭弹窗
                        this.formIsVisible = false;
                    }
                });
        },
        loadTableData() {
            this.editData = {};
            this.editDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/hybm/listMx",
                    {
                        id: this.dataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.tableData = data.data;
                        } else {
                            // 加载的数据不存在则提示错误并返回列表
                            this.$FG_message.error("P0002").then(() => (this.editIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则返回列表
                        this.formIsVisible = false;
                    }
                });
        },
        unSubmit() {
            this.$FG_http
                .post("./api/main/hybm/bmlr/unSubmit", {
                    id: this.editData.id
                })
                .then(({ success, data, errMsg }) => {
                    this.tableDataLoading = false;
                    if (success) {
                        // 设置当前行
                        this.editDataId = this.editData.id;
                        // 返回列表
                        this.onBack();
                    } else {
                        this.$refs.hymc.focus();
                    }
                });
        },

        // 返回列表
        onBack() {
            this.formIsVisible = false;
        },
        initOperLog() {
            this.operLogProps.visible = true;
            this.operLogProps.billid = this.editData.id;
        }
    }
};
</script>
<style lang="scss" scoped>
.view {
    background: #fff;
    border: 0;
    color: #333;
    cursor: inherit;
}
.zpCls {
    width: 181px;
    height: 181px;
}
</style>
<style>
.cusBtnAlign .ant-modal-footer {
    text-align: center !important;
}
.view .ant-select-selection.ant-select-selection--single {
    background: #fff;
    border: 0px;
    cursor: inherit;
}
.view span.ant-select-arrow {
    display: none;
}
.view input.ant-calendar-picker-input.ant-input.ant-input-disabled {
    background: #fff;
    border: 0;
    color: #333;
    cursor: auto;
}
.view .ant-calendar-picker-icon {
    display: none;
    cursor: auto;
}
</style>
